import type { Pos } from '~entities/pos';

import type { AbstractOption } from '~shared/types/abstract-options';

export const getPointsOfSaleOptions = (
  posList: Pos[]
): AbstractOption<string>[] => {
  return posList.map((pos) => ({
    value: pos.id,
    title: pos.name,
    description: pos.fullAddress,
    checkmarkStyle: 'checkbox',
  }));
};
